<template>
  <VPopup
    position="bottom"
    align="right"
    show-pointer
    :visible="true"
    :target="target"
    padding="10px"
    :css-classes="['change-currency-popup']"
  >
    <VSelectV2
      v-model="localCurrency"
      placeholder="Выберите валюту"
      :data="$core.currencies.currencies"
    />

    <VButtonGroup>
      <VButton
        theme="primary"
        :disabled="localCurrency === null"
        @click="save"
      >
        Сохранить
      </VButton>
      <VButton @click="close">
        Отменить
      </VButton>
    </VButtonGroup>
  </VPopup>
</template>

<style lang="scss" src="./TenderChangeCurrencyPopup.scss" />

<script lang="ts">
import type Currency from '@/domains/Currencies/Currency';

export default defineComponent({
  name: 'TenderChangeCurrencyPopup',

  props: {
    target: {
      type:    HTMLElement,
      default: null,
    },
  },

  emits: ['save'],

  data() {
    return {
      localCurrency: null as Currency | null,
    };
  },

  methods: {
    save(): void {
      this.$emit('save', this.localCurrency);
      this.$core.dialogs.TenderChangeCurrencyPopup.hide();
    },

    close(): void {
      this.$core.dialogs.TenderChangeCurrencyPopup.hide();
    },
  },
});
</script>
